<div class="skeletor-docreq">
  <div class="skeletor-docreq-header">
    <p-skeleton [width]="'16rem'" [height]="'1.2rem'" />
    <p-skeleton [width]="'24rem'" [height]="'1rem'" />
  </div>

  <div class="skeletor-docreq-panel">
    <div class="skeletor-docreq-toolbar">
      <div>
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton [width]="'20rem'" [height]="'0.9rem'" />
      </div>
      <p-skeleton [width]="'12rem'" [height]="'2.2rem'" />
    </div>

    <div class="skeletor-docreq-list">
      <div class="skeletor-docreq-item" *ngFor="let i of rows">
        <div class="skeletor-docreq-item-head">
          <p-skeleton [width]="'12rem'" [height]="'1rem'" />
          <div class="skeletor-docreq-actions">
            <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
            <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
          </div>
        </div>

        <div class="skeletor-chip-row">
          <p-skeleton [width]="'10rem'" [height]="'1.2rem'" />
          <p-skeleton [width]="'10rem'" [height]="'1.2rem'" />
          <p-skeleton [width]="'6rem'" [height]="'1.2rem'" />
          <p-skeleton [width]="'6rem'" [height]="'1.2rem'" />
          <p-skeleton [width]="'6rem'" [height]="'1.2rem'" />
        </div>

        <div class="skeletor-docreq-item-meta">
          <p-skeleton [width]="'12rem'" [height]="'0.9rem'" />
          <p-skeleton [width]="'12rem'" [height]="'0.9rem'" />
          <p-skeleton [width]="'14rem'" [height]="'0.9rem'" />
        </div>
      </div>
    </div>
  </div>
</div>

